import { render } from "./Youtube.vue?vue&type=template&id=17ab66ed"
import script from "./Youtube.vue?vue&type=script&lang=js"
export * from "./Youtube.vue?vue&type=script&lang=js"
script.render = render

export default script